import { cn } from '@fshr/shared-react';
import type { CSSProperties } from 'react';
import type { LayoutMode } from '../layout/column-width-functions';

export function getColumnStyle(
	colIndex: number,
	columnWidths: (number | undefined)[] | null,
	layoutMode: LayoutMode
): CSSProperties | undefined {
	const width = columnWidths?.[colIndex];
	if (width == null) {
		return undefined;
	}

	return {
		width,
		minWidth: width,
		maxWidth: width,
		flexShrink: 0,
		overflow: layoutMode === 'scroll' && colIndex > 0 ? 'hidden' : undefined,
	};
}

export function getCellLayoutClassName(
	colIndex: number,
	isHorizontalOverflow: boolean,
	isCompressed: boolean,
	hasColumnWidths: boolean
): string {
	if (hasColumnWidths) {
		return colIndex > 0 && isHorizontalOverflow && isCompressed ? 'min-w-0' : 'shrink-0';
	}

	if (isHorizontalOverflow && isCompressed) {
		return colIndex > 0 ? 'min-w-0' : 'shrink-0';
	}

	if (colIndex === 0) {
		return 'min-w-[150px] shrink-0';
	}

	return 'min-w-[125px] min-w-0 shrink-0';
}

export function getStickyFirstColumnClassName(
	colIndex: number,
	stickyRowHeader: boolean,
	isHorizontalOverflow: boolean,
	isStickyScrolled: boolean,
	isHeader: boolean
): string {
	if (!stickyRowHeader || !isHorizontalOverflow || colIndex !== 0) {
		return '';
	}

	return cn(
		'relative sticky left-0 z-[1]',
		isHeader
			? 'z-[2] bg-surface-raised-subtle'
			: 'bg-surface-default group-hover/row:bg-surface-raised-subtle',
		isStickyScrolled && ['shadow-[5px_0_15px_0_rgba(3,3,3,0.12)]', '[clip-path:inset(0_-28px_0_0)]']
	);
}
